import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const inputClasses =
  'w-full rounded-lg border border-stone-300 bg-white px-4 py-3 text-sm text-stone-900 focus:border-lime-500 focus:ring-2 focus:ring-lime-200';

const LoginPage = () => {
  const { login, register, isAuthenticated, authError } = useAuth();
  const [mode, setMode] = useState('login');
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    password: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setSuccessMessage('');

    const action =
      mode === 'login'
        ? () => login(formState.email, formState.password)
        : () => register(formState.name, formState.email, formState.password);

    const result = await action();
    if (result.success) {
      setSuccessMessage(mode === 'login' ? 'Welcome back!' : 'Account created – head to the dashboard.');
    }
    setSubmitting(false);
  };

  return (
    <div className="flex min-h-screen flex-col bg-[#0f0604] text-white lg:flex-row">
      <div className="flex flex-1 flex-col justify-between bg-cover bg-center p-10"
        style={{ backgroundImage: 'url(https://ik.imagekit.io/hqhiltiie/Nyinimu/Houses/avi-werde-hHz4yrvxwlA-unsplash.jpg)' }}>
        <div>
          <p className="text-sm uppercase tracking-[0.5em] text-white/60">Nyinimu Admin</p>
          <h1 className="mt-6 text-4xl font-semibold leading-tight">
             <br /> 
          </h1>
        </div>
        <p className="text-sm text-white/70">
This Site was created by Kenpro Media a product Smari Creatives Ltd       </p>
      </div>

      <div className="flex flex-1 items-center justify-center bg-white/5 px-10 py-14 backdrop-blur">
        <form onSubmit={handleSubmit} className="w-full max-w-md space-y-6 rounded-3xl border border-white/10 bg-white/5 p-8 shadow-2xl">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-semibold text-white">
              {mode === 'login' ? 'Sign in to Dashboard' : 'Create Admin Account'}
            </h2>
            <Link to="/" className="text-sm text-lime-300 hover:text-lime-200">
              Back to Site
            </Link>
          </div>

          {mode === 'register' && (
            <div className="space-y-2">
              <label className="text-xs uppercase tracking-[0.3em] text-white/70">Name</label>
              <input
                type="text"
                name="name"
                className={inputClasses}
                value={formState.name}
                onChange={(e) => setFormState((prev) => ({ ...prev, name: e.target.value }))}
                placeholder="Nyinimu Admin"
                required
              />
            </div>
          )}

          <div className="space-y-2">
            <label className="text-xs uppercase tracking-[0.3em] text-white/70">Email</label>
            <input
              type="email"
              name="email"
              className={inputClasses}
              value={formState.email}
              onChange={(e) => setFormState((prev) => ({ ...prev, email: e.target.value }))}
              placeholder="admin@nyinimu.com"
              required
            />
          </div>

          <div className="space-y-2">
            <label className="text-xs uppercase tracking-[0.3em] text-white/70">Password</label>
            <input
              type="password"
              name="password"
              className={inputClasses}
              value={formState.password}
              onChange={(e) => setFormState((prev) => ({ ...prev, password: e.target.value }))}
              placeholder="••••••••"
              required
            />
          </div>

          {authError && <p className="rounded-xl bg-red-500/20 px-4 py-2 text-sm text-red-100">{authError}</p>}
          {successMessage && <p className="rounded-xl bg-lime-500/20 px-4 py-2 text-sm text-lime-100">{successMessage}</p>}

          <button
            type="submit"
            disabled={submitting}
            className="w-full rounded-xl bg-lime-400 py-3 text-sm font-semibold uppercase tracking-[0.3em] text-stone-900 hover:bg-lime-300 disabled:opacity-50"
          >
            {submitting ? 'Please wait…' : mode === 'login' ? 'Sign In' : 'Create Account'}
          </button>

          <p className="text-center text-sm text-white/70">
            {mode === 'login' ? (
              <>
                Need an account?{' '}
                <button type="button" className="text-lime-300" onClick={() => setMode('register')}>
                  Register
                </button>
              </>
            ) : (
              <>
                Already onboard?{' '}
                <button type="button" className="text-lime-300" onClick={() => setMode('login')}>
                  Login
                </button>
              </>
            )}
          </p>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
